import { useState } from "react";
import TableFull from "./table-full";
import TableSummarized from "./table-summarized";
import DialogExport from "./dialog-export";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import useLogs from "hooks/logs";

export const LONGTERM_STATUS = new Map([
  ["AB", "Aberto"],
  ["CA", "Cancelado"],
  ["LQ", "Liquidado"],
  ["LS", "Liquidado Substituído"],
]);

export default function TableView({
  data,
  totalRegistros,
  page,
  sizePerPage,
  onTableChange,
  viewType,
}) {
  const [openExportBoletos, setOpenExportBoletos] = useState(false);
  const [selectedTitles, setSelectedTitles] = useState([]);

  const { setLocalStorageActions } = useLogs();
  const snackbar = useSnackbar();

  const downloadBoleto = (url) => {
    const safeUrl = url != null ? String(url).trim() : "";
    if (!safeUrl) {
      snackbar.showMessage(
        "Este boleto ainda não está disponível para download.",
        { severity: "info" },
      );
      return;
    }
    window.open(safeUrl, "_blank");

    setLocalStorageActions({
      nomeTela: "Relatório de Acompanhamento de Títulos",
      idMenu: "108",
      acao: "Download do Boleto",
    });
  };

  const handleExportBoletos = (selectedRows) => {
    setOpenExportBoletos(true);
    setSelectedTitles(selectedRows);
  };

  return (
    <>
      {viewType === "full" ? (
        <TableFull
          data={data}
          onExportBoletos={handleExportBoletos}
          downloadBoleto={downloadBoleto}
          totalRegistros={totalRegistros}
          page={page}
          sizePerPage={sizePerPage}
          onTableChange={onTableChange}
        />
      ) : (
        <TableSummarized
          data={data}
          downloadBoleto={downloadBoleto}
          onExportBoletos={handleExportBoletos}
          totalRegistros={totalRegistros}
          page={page}
          sizePerPage={sizePerPage}
          onTableChange={onTableChange}
        />
      )}
      {openExportBoletos && (
        <DialogExport
          onClose={() => setOpenExportBoletos(false)}
          titles={selectedTitles}
        />
      )}
    </>
  );
}
